module.exports = __webpack_public_path__ + "static/media/1009256.34abdeb7.png";